;(function () {
  var API_BASE_URL = 'https://nordik-test-shipping-api.vercel.app'
  // var NOTIFY_ENDPOINT = API_BASE_URL + '/api/notify';

  document.querySelectorAll('.nordik-availability').forEach(initWidget)

  function initWidget(root) {
    var state = root.getAttribute('data-state')
    if (state === 'out-of-stock') {
      return
    }

    resolveAvailability(root)
  }

  function apiUrl(params, variantId, locale) {
    return (
      API_BASE_URL +
      '/api/rates?' +
      params +
      (variantId ? '&variant_id=' + encodeURIComponent(variantId) : '') +
      (locale ? '&locale=' + encodeURIComponent(locale) : '')
    )
  }

  function fetchRates(params, variantId, locale) {
    return fetch(apiUrl(params, variantId, locale)).then(function (res) {
      if (!res.ok) throw new Error('Request failed')
      return res.json()
    })
  }

  function bestEtaText(data) {
    var withEta = (data.rates || []).find(function (r) {
      return r.etaText
    })
    return withEta ? withEta.etaText : null
  }

  // ---------- Shared: resolve which panel to show, no consent gate ----------

  var RESOLVED_POSTAL_SESSION_KEY = 'nordikResolvedPostal'

  function startRequest(root) {
    var gen = parseInt(root.dataset.nordikRequestGen || '0', 10) + 1
    root.dataset.nordikRequestGen = String(gen)
    return gen
  }
  function isStale(root, gen) {
    return String(gen) !== root.dataset.nordikRequestGen
  }

  function resolveAvailability(root) {
    var variantId = root.getAttribute('data-variant-id')
    // Set by Liquid from {{ request.locale.iso_code }} — see the
    // data-locale attribute on the widget's root element.
    var locale = root.dataset.locale
    var cachedPostal = window.sessionStorage.getItem(
      RESOLVED_POSTAL_SESSION_KEY,
    )
    var gen = startRequest(root)

    var lookup = cachedPostal
      ? fetchRates(
          'postal=' + encodeURIComponent(cachedPostal),
          variantId,
          locale,
        )
      : fetchRates('auto=true', variantId, locale).then(function (data) {
          if (data.detectedAutomatically && data.postalValid && data.postal) {
            window.sessionStorage.setItem(
              RESOLVED_POSTAL_SESSION_KEY,
              data.postal,
            )
          }
          return data
        })

    lookup
      .then(function (data) {
        if (isStale(root, gen)) return

        if (!data.postalValid || !data.postal) {
          root.setAttribute('data-state', 'in-stock')
          initInStock(root, variantId, { skipAutoDetect: true })
          return
        }
        if (data.isPreOrder) {
          root.setAttribute('data-state', 'preorder')
          initPreorder(root, variantId, { initialData: data })
        } else {
          root.setAttribute('data-state', 'in-stock')
          initInStock(root, variantId, { initialData: data })
        }
      })
      .catch(function () {
        if (isStale(root, gen)) return
        root.setAttribute('data-state', 'in-stock')
        initInStock(root, variantId, { skipAutoDetect: true })
      })
  }

  // ---------- In stock ----------
  function initInStock(root, variantId, opts) {
    opts = opts || {}
    var locale = root.dataset.locale
    var deliveryText = root.querySelector('[data-text="delivery-line"]')
    var locationText = root.querySelector('[data-text="location-line"]')
    var editBtn = root.querySelector('[data-action="edit-postal"]')
    var form = root.querySelector('[data-form="postal"]')
    var input = root.querySelector('[data-input="postal"]')
    var error = root.querySelector('[data-error="postal"]')

    function applyResult(data) {
      if (data.postalValid === false) {
        error.textContent = root.dataset.invalidPostalError
        error.hidden = false
        return
      }
      error.hidden = true
      if (data.rates && data.rates.length) {
        var eta = bestEtaText(data)
        deliveryText.textContent = eta || root.dataset.deliveryAvailableFallback
      } else {
        // Admin-editable — set via data-delivery-prompt on the root
        // element in the Liquid snippet (this .js file isn't processed
        // by Liquid, so it can't receive the value directly).
        deliveryText.textContent = root.dataset.deliveryPrompt
      }
      locationText.textContent = data.postal
        ? root.dataset.deliveringToPrefix + data.postal
        : root.dataset.locationPrompt
      editBtn.hidden = false
    }

    function lookupManual(postal) {
      var gen = startRequest(root)
      fetchRates('postal=' + encodeURIComponent(postal), variantId, locale)
        .then(function (data) {
          if (isStale(root, gen)) return
          if (data.postalValid === false) {
            error.textContent = root.dataset.invalidPostalError
            error.hidden = false
            return
          }

          window.sessionStorage.setItem(RESOLVED_POSTAL_SESSION_KEY, postal)

          if (data.isPreOrder) {
            root.setAttribute('data-state', 'preorder')
            initPreorder(root, variantId, { initialData: data })
            return
          }
          error.hidden = true
          applyResult(data)
          form.hidden = true
        })
        .catch(function () {
          if (isStale(root, gen)) return
          error.textContent = root.dataset.genericError
          error.hidden = false
        })
    }

    if (!form.dataset.nordikBound) {
      form.dataset.nordikBound = 'true'

      editBtn.addEventListener('click', function () {
        error.hidden = true
        input.value = ''
        form.hidden = false
        input.focus()
      })

      form.addEventListener('submit', function (event) {
        event.preventDefault()
        var postal = input.value.trim()
        if (!postal) return
        lookupManual(postal)
      })
    }

    if (opts.initialData) {
      applyResult(opts.initialData)
      form.hidden = true
      input.value = ''
      error.hidden = true
    } else {
      form.hidden = false
    }
  }

  // ---------- Pre-order ----------
  function initPreorder(root, variantId, opts) {
    opts = opts || {}
    var locale = root.dataset.locale
    var preorderText = root.querySelector('[data-text="preorder-line"]')
    var locationText = root.querySelector(
      '[data-text="preorder-location-line"]',
    )
    var editBtn = root.querySelector('[data-action="preorder-edit-postal"]')
    var form = root.querySelector('[data-form="preorder-postal"]')
    var input = root.querySelector('[data-input="preorder-postal"]')
    var error = root.querySelector('[data-error="preorder-postal"]')

    function applyResult(data) {
      if (data.postalValid === false) {
        error.textContent = root.dataset.invalidPostalError
        error.hidden = false
        return
      }
      error.hidden = true
      var eta = bestEtaText(data)
      if (eta) preorderText.textContent = eta
      locationText.textContent = data.postal
        ? root.dataset.estimatedForPrefix + data.postal
        : ''
      editBtn.hidden = false
    }

    function lookupManual(postal) {
      var gen = startRequest(root)
      fetchRates('postal=' + encodeURIComponent(postal), variantId, locale)
        .then(function (data) {
          if (isStale(root, gen)) return
          if (data.postalValid === false) {
            error.textContent = root.dataset.invalidPostalError
            error.hidden = false
            return
          }

          window.sessionStorage.setItem(RESOLVED_POSTAL_SESSION_KEY, postal)

          if (!data.isPreOrder) {
            root.setAttribute('data-state', 'in-stock')
            initInStock(root, variantId, { initialData: data })
            return
          }
          error.hidden = true
          applyResult(data)
          form.hidden = true
        })
        .catch(function () {
          if (isStale(root, gen)) return
          error.textContent = root.dataset.genericError
          error.hidden = false
        })
    }

    if (!form.dataset.nordikBound) {
      form.dataset.nordikBound = 'true'

      editBtn.addEventListener('click', function () {
        error.hidden = true
        input.value = ''
        form.hidden = false
        input.focus()
      })

      form.addEventListener('submit', function (event) {
        event.preventDefault()
        var postal = input.value.trim()
        if (!postal) return
        lookupManual(postal)
      })
    }

    if (opts.initialData) {
      applyResult(opts.initialData)
      form.hidden = true
      input.value = ''
      error.hidden = true
    } else {
      form.hidden = false
    }
  }

  // ---------- Out of stock ----------
  // function initNotifyForm(root) {
  //   var form = root.querySelector('[data-form="notify"]');
  //   var input = root.querySelector('[data-input="notify-email"]');
  //   var error = root.querySelector('[data-error="notify"]');
  //   var formView = root.querySelector('[data-view="notify-form"]');
  //   var confirmedView = root.querySelector('[data-view="notify-confirmed"]');

  //   form.addEventListener('submit', function (event) {
  //     event.preventDefault();
  //     var email = input.value.trim();
  //     if (!isValidEmail(email)) {
  //       error.hidden = false;
  //       return;
  //     }
  //     error.hidden = true;

  //     if (!NOTIFY_ENDPOINT) {
  //       console.warn('Nordik widget: NOTIFY_ENDPOINT not configured yet — email not sent:', email);
  //       confirmedView.hidden = false;
  //       formView.hidden = true;
  //       return;
  //     }

  //     fetch(NOTIFY_ENDPOINT, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ email: email, variantId: root.getAttribute('data-variant-id') }),
  //     })
  //       .then(function () {
  //         confirmedView.hidden = false;
  //         formView.hidden = true;
  //       })
  //       .catch(function () {
  //         error.hidden = false;
  //       });
  //   });
  // }

  // function isValidEmail(value) {
  //   return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  // }
})()
